// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607161017/js/" + chunkId + "." + {"44":"4fd189c4","225":"bc5ca83a","481":"77dcf192","486":"b174aab5","770":"f1166a2b"}[chunkId] + ".0.5872586443935071.chunk.js";
};